export enum ASK_LUMAPPS_ADMIN {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=460509904
     */
    SEARCH_AI = 'ASK_LUMAPPS_ADMIN.SEARCH_AI',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=470718847
     */
    CONCEPTS = 'ASK_LUMAPPS_ADMIN.CONCEPTS',
}
